<template>
    <div class="flex flex-1 justify-center" />
</template>

<script>
export default {
    name: 'LayoutDefault',
};
</script>
